import React, {
	Component,
	PropTypes
} from 'react';
import {
	domainUrl
} from '../config/Config';
import {
	reactLoader,
	objToSlashString,
	setTokenData
} from '../helpers/Common';
import DmWall from '../partials/DmWall';
const $ = window.$;
const styles = {
	justifyContent: 'center',
	alignItems: 'center',
	display: 'flex',
	float: 'left',
	width: '100%',
	position: 'absolute',
	height: '100%'
};
export default class DmWallLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			compBlock: null
		};
	}
	noAuthorizedPage() {
		return <div style={styles}>You are not authorized to access this page!</div>
	}
	getComponent() {
		this.setState({
			compBlock: <DmWall autoload={true} />
		})
	}
	componentDidMount() {
		reactLoader("show", "Please wait...");
		let query_data = objToSlashString({
			app_code: this.props.params.app_code,
			device_id: this.props.params.device_id
		});
		fetch(domainUrl + 'mobile/learner/check' + query_data, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		}).then((response) => response.json()).then((responseJson) => {
			if (responseJson.status === 1) {
				setTokenData("token", responseJson.data.token);
				this.getComponent();
			} else {
				this.setState({
					compBlock: this.noAuthorizedPage()
				})
			}
			reactLoader("hide");
		});
	}
	render() {
		return (<div>
                {this.state.compBlock}
            </div>)
	}
}



// WEBPACK FOOTER //
// ./src/layouts/DmWallLayout.js